module.exports = __webpack_public_path__ + "img/left_arrow.f94b1eb0.png";